import { mount } from "svelte";
import "./app.css";
import App from "./App.svelte";
import { cart } from "./lib/cart-store.svelte.js";

// Keep track of the mounted instance to avoid re-mounting on every update.
let appInstance;

function renderCart(element, props = {}) {
  const target = element || document.querySelector("#app");

  if (!target) {
    console.warn(`ShoppingCart target element not found.`);
    return;
  }

  // Mount the App only once.
  if (!appInstance) {
    appInstance = mount(App, { target });
  }

  // Initialize/update the store with the latest props from Bubble.
  cart.actions.init(props);
}

// The new, simplified "CartFast" API for the Bubble plugin to use.
export const CartFast = {
  renderCart,
  ...cart.actions,
};
